export interface RadarAxisConfig {
  key: string;
  label: string;
  description: string;
  min: number;
  max: number;
  defaultPreference: number;
}

// ---- HEAD AXES ----
// To add/remove: edit this array only. Chart, sliders, and API all auto-adapt.
export const HEAD_AXES: RadarAxisConfig[] = [
  { key: 'forgiveness',  label: 'Forgiveness',  description: 'Mis-hit tolerance',            min: 1, max: 10, defaultPreference: 5 },
  { key: 'launch',       label: 'Launch',        description: 'Launch angle tendency',        min: 1, max: 10, defaultPreference: 5 },
  { key: 'spin',         label: 'Spin',          description: 'Spin level',                   min: 1, max: 10, defaultPreference: 5 },
  { key: 'workability',  label: 'Workability',   description: 'Shot shaping ability',         min: 1, max: 10, defaultPreference: 5 },
  { key: 'technology',   label: 'Technology',    description: 'Engineering sophistication',   min: 1, max: 10, defaultPreference: 7 },
];

// ---- SHAFT AXES ----
export const SHAFT_AXES: RadarAxisConfig[] = [
  { key: 'stiffness_fit',  label: 'Stiffness Fit',  description: 'Flex match to swing',         min: 1, max: 10, defaultPreference: 5 },
  { key: 'weight_fit',     label: 'Weight Fit',      description: 'Weight match to profile',     min: 1, max: 10, defaultPreference: 5 },
  { key: 'launch_profile', label: 'Launch Profile',  description: 'Shaft launch character',      min: 1, max: 10, defaultPreference: 5 },
  { key: 'spin_profile',   label: 'Spin Profile',    description: 'Shaft spin character',        min: 1, max: 10, defaultPreference: 5 },
  { key: 'stability',      label: 'Stability',       description: 'Face stability / low torque', min: 1, max: 10, defaultPreference: 5 },
];

// ---- IRON HEAD AXES ----
// Iron heads use 'feel' instead of driver's 'technology'
export const IRON_HEAD_AXES: RadarAxisConfig[] = [
  { key: 'forgiveness',  label: 'Forgiveness',  description: 'Mis-hit tolerance',            min: 1, max: 10, defaultPreference: 5 },
  { key: 'launch',       label: 'Launch',        description: 'Launch angle tendency',        min: 1, max: 10, defaultPreference: 5 },
  { key: 'spin',         label: 'Spin',          description: 'Spin level',                   min: 1, max: 10, defaultPreference: 5 },
  { key: 'workability',  label: 'Workability',   description: 'Shot shaping ability',         min: 1, max: 10, defaultPreference: 5 },
  { key: 'feel',         label: 'Feel',          description: 'Feedback and softness',        min: 1, max: 10, defaultPreference: 5 },
];

// ---- IRON SHAFT AXES ----
// Iron shafts use 'material_fit' instead of driver's 'stability'
export const IRON_SHAFT_AXES: RadarAxisConfig[] = [
  { key: 'stiffness_fit',  label: 'Stiffness Fit',  description: 'Flex match to swing',           min: 1, max: 10, defaultPreference: 5 },
  { key: 'weight_fit',     label: 'Weight Fit',      description: 'Weight match to profile',       min: 1, max: 10, defaultPreference: 5 },
  { key: 'launch_profile', label: 'Launch Profile',  description: 'Shaft launch character',        min: 1, max: 10, defaultPreference: 5 },
  { key: 'spin_profile',   label: 'Spin Profile',    description: 'Shaft spin character',          min: 1, max: 10, defaultPreference: 5 },
  { key: 'material_fit',   label: 'Material Fit',    description: 'Steel vs graphite suitability', min: 1, max: 10, defaultPreference: 5 },
];
